import { Box, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { withAlpha } from '../indicacao.utils';

interface SectionHeaderProps {
	icon: ReactNode;
	titulo: string;
	descricao?: string;
	acao?: ReactNode;
}

export function SectionHeader({ icon, titulo, descricao, acao }: SectionHeaderProps) {
	const theme = useTheme();
	const primary = theme.palette.primary.main;

	return (
		<Box
			display="flex"
			justifyContent="space-between"
			alignItems={{ xs: 'flex-start', sm: 'center' }}
			flexDirection={{ xs: 'column', sm: 'row' }}
			gap={2}
		>
			<Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
				<Box
					sx={{
						width: 44,
						height: 44,
						borderRadius: 2.5,
						flexShrink: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						color: primary,
						bgcolor: withAlpha(primary, 0.12),
					}}
				>
					{icon}
				</Box>
				<Box minWidth={0}>
					<Typography fontWeight={800} fontSize="1.05rem">
						{titulo}
					</Typography>
					{descricao && (
						<Typography fontSize="0.875rem" color="text.secondary">
							{descricao}
						</Typography>
					)}
				</Box>
			</Box>
			{acao}
		</Box>
	);
}
